import { useEffect, useRef, useState } from "react";
import { T } from "react-translator-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { ErrorMessageModal } from "../../../components/ErrorMessageModal";
import QrReader from "../../../components/QrReader";
import LoadingModal from "../../../components/LoadingModal";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import "../../../components/qr.css";
import { styles } from "../../styles";
import appServices from "../../../services/app-services/appServices";

const ChangeCameraAndQrcode = () => {
  const defaultImage = require("../../../assets/images/default.png");

  // 初回実行
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const refCameraQrArea = useRef<HTMLDivElement>(null!);
  const [scanedCode, setScanedCode] = useState<string>("");

  const navigate = useNavigate();
  const groupInfo = useSelector((state: any) => state.gcGroup);

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string[]>([]);
  const showErrorMessage = errorMessage.length > 0

  const handleQRCode = async (qrcode: string) => {
    setLoading(true);
    try {
      await appServices.getShopInfo(qrcode).then((res) => {
        setLoading(false);
        navigate("/paymentInfo", { state: { shopInfo: res.shop_information } });
      });
    } catch (error: any) {
      console.error(error);
      setErrorMessage(error?.response?.data?.message ?? T("api_unknown_error"));
      setLoading(false);
    }
  };

  // QRコードを読み込んだとき
  useEffect(() => {
    // 開発環境で店舗支払いの動作確認したい場合は以下を使用して下さい。
    // handleQRCode("dummy");

    if (scanedCode === undefined || scanedCode === null || scanedCode === "") return;
    if (errorMessage.length > 0) return;

    const permitQrTextPattern = /^https:\/\/www(-sandbox)?\.pokepay\.jp\/bills\/([a-f0-9\-]+)$/;
    const match = scanedCode.match(permitQrTextPattern);

    if (match) {
      const qr_id = match[2];
      handleQRCode(qr_id);
    } else {
      alert(T("scan_qr_error"));
    }

    // 読み込んだQRコード値をクリア
    setScanedCode("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanedCode]);

  return (
    <div style={{ paddingTop: 100, marginLeft: 16, height: '100vh' }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <LoadingModal visible={loading} />
      <Box style={{ padding: 16 }}>
        <Typography style={{ fontWeight: "700" }}>
          <img
            src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : defaultImage}
            alt={"img"}
            style={{
              ...styles.farmProfileIcon,
              height: 40,
              width: 40,
              margin: 0,
            }}
          />
          &nbsp;{groupInfo?.groupName}
        </Typography>
      </Box>

      {/* QR Scanner */}
      <div className="qr-reader">
        <div className="qr-title">
          {T("scan_qr_read_code")}
        </div>
        <div ref={refCameraQrArea}>
          <div className="camera-container">
            <QrReader
              scanedCode={scanedCode}
              setScanedCode={setScanedCode}
            />
          </div>
        </div>
        <div className="qr-description">
          {T("scan_qr_trademark")}
        </div>
      </div>

      <ErrorMessageModal
        open={showErrorMessage}
        messages={errorMessage}
        onClose={() => setErrorMessage([])}
      />
    </div>
  );
};

export default ChangeCameraAndQrcode;
